import React from 'react';

import type { IndustrialCaseSummary } from '@/domain/industrialCase/industrialCaseSummary';

import ClaimEvidenceSection from './section/claimEvidence/ClaimEvidenceSection';
import ClientUseCases from './section/clientUseCases/ClientUseCases';
import { HomeFaqSection } from './section/faq/HomeFaqSection';
import HeroBanner from './section/heroBanner/HeroBanner';
import ListenAiSection from './section/listenAi/ListenAiSection';
import Partners from './section/partners/Partners';
import ProofStatsSection from './section/proofStats/ProofStatsSection';
import SoundAnalytics from './section/soundAnalytics/SoundAnalytics';

type Props = {
  industrialCases: ReadonlyArray<IndustrialCaseSummary>;
};

/**
 * ### Home
 *
 * Composes the public home page sections and passes server-published customer
 * cases into the case surface. Sections own their visual and interaction rules.
 *
 * @param props Published Industrial cases for the current locale
 * @returns The rendered home page sections
 */
export default function Home({ industrialCases }: Props) {
  return (
    <>
      {/* Sound into Insight: 브랜드 문장만 두는 첫 화면 */}
      <HeroBanner />

      {/* 생산라인 일러스트와 프레스킷 Core Message */}
      <ClaimEvidenceSection />

      {/* 3대 지표와 내러티브: 왼쪽 숫자가 오른쪽 스크롤을 따라 바뀐다. CTA로 닫는다 */}
      <ProofStatsSection />

      {/* Listen AI */}
      <ListenAiSection />

      {/* 세계 최고 수준의 실시간 사운드 분석 AI */}
      <SoundAnalytics />

      {/* Listen AI를 활용한 다양한 고객 사례 */}
      <ClientUseCases cases={industrialCases} />

      {/* 기술 혁신을 함께 이끌어가는 고객사 · 협력사 · 파트너사 */}
      <Partners />

      {/* Renders the copy the route also emits as FAQPage structured data */}
      <HomeFaqSection />
    </>
  );
}
